import styled from 'styled-components';

const PartnerSectionWrapper = styled.section `
  padding: 40px 120px;
  background-repeat: no-repeat;
  background-position: 25% center;
  background-color: #f9f9f9;

  @media (max-width: 990px) {
    padding: 100px 0;
  }
  @media (max-width: 767px) {
    padding: 80px 0;
  }
  @media (max-width: 575px) {
    padding: 60px 0 0;
  }
`;
export default PartnerSectionWrapper;